export enum PremiumErrorCode {
  PremiumNotFound = 'PREMIUM_NOT_FOUND',
  NotEnoughPaid = 'NOT_ENOUGH_PAID',
  TransactionNotFound = 'TRANSACTION_NOT_FOUND',
  NoProcessingBoosters = 'NO_PROCESSING_BOOSTERS',
  PremiumAlreadyPurchased = 'PREMIUM_ALREADY_PURCHASED',
  ImageSafetyCheckFailed = 'IMAGE_SAFETY_CHECK_FAILED',
  ImageContentNotSafe = 'IMAGE_CONTENT_NOT_SAFE',
  ExpireTimeMoreThan7Days = 'EXPIRE_TIME_MORE_THAN_7_DAYS',
}

export enum AuthErrorCode {
  Unauthorized = 'UNAUTHORIZED',
  UserNotFound = 'cas::errors::user::not_found',
  OTPRequired = 'cas::errors::auth::otp_required',
  InvalidCredentials = 'cas::errors::user::invalid_credentials',
  InvalidToken = 'cas::errors::auth::invalid_token',
  InvalidOTP = 'cas::errors::user::invalid_otp',
  UserAlreadyExists = 'cas::errors::user::user_already_exists',
  InviterNotFound = 'cas::errors::referral::inviter_not_found',
  InvalidPassword = 'cas::errors::user::invalid_password',
}

export enum FastifyErrorCode {
  ContentBodyTooLarge = 'FST_ERR_CTP_BODY_TOO_LARGE',
}

export enum ServicesErrorCode {
  PoolNotFound = 'POOL_NOT_FOUND',
  PoolAddressInvalid = 'POOL_ADDRESS_INVALID',
  PoolFetchFailed = 'POOL_FETCH_FAILED',
  PoolsFetchFailed = 'POOLS_FETCH_FAILED',
  InfuraNotResponding = 'INFURA_NOT_RESPONDING',
  TokenNotFound = 'TOKEN_NOT_FOUND',
  PairNotFound = 'PAIR_NOT_FOUND',
  TokenAddressRequired = 'TOKEN_ADDRESS_REQUIRED',
  TokenAddressInvalid = 'TOKEN_ADDRESS_INVALID',
  NetworkNotSupported = 'NETWORK_NOT_SUPPORTED',
  PositionNotFound = 'POSITION_NOT_FOUND',
  SwapNotFound = 'SWAP_NOT_FOUND',
  NotEnoughLiquidity = 'NOT_ENOUGH_LIQUIDITY',
  TransactionFailed = 'TRANSACTION_FAILED',
  // duplicated in SwapErrorCode
  // InsufficientBalance = 'INSUFFICIENT_BALANCE',
  SignatureRequired = 'SIGNATURE_REQUIRED',
}

export enum UserErrorCode {
  // Thrown on login and refresh token endpoints
  OtpRequired = 'cas::errors::user::otp_required',
}

export enum TradeErrorCode {
  NoActivePosition = 'NO_ACTIVE_POSITION',
  NotSupportedProvider = 'NOT_SUPPORTED_PROVIDER',
  ApproveInsufficientFunds = 'APPROVE_INSUFFICIENT_FUNDS',
  SwapInsufficientFunds = 'SWAP_INSUFFICIENT_FUNDS',
  UnsupportedNetwork = 'UNSUPPORTED_NETWORK',
  AllowanceNotFetched = 'ALLOWANCE_NOT_FETCHED',
  RequiredArgumentMissing = 'REQUIRED_ARGUMENT_MISSING',
  TransactionMissing = 'TRANSACTION_MISSING',
  SwapOrderNotFound = 'SWAP_ORDER_NOT_FOUND',
  TransactionSend = 'TRANSACTION_SEND',
  InvalidAmount = 'INVALID_AMOUNT',
  CreateSwapTransaction = 'UNABLE_TO_CREATE_SWAP_TRANSACTION',
  Database = 'DATABASE',
}

export enum WalletErrorCode {
  WalletNotFound = 'WALLET_NOT_FOUND',
  AssetAlreadyAdded = 'ASSET_ALREADY_ADDED',
  WalletAlreadyAdded = 'WALLET_ALREADY_ADDED',
  WalletSignError = 'WALLET_SIGN_ERROR',
  InvalidPrivateKey = 'INVALID_PRIVATE_KEY',
  /** The key is on somebody's machine, so there is nothing here to give back. */
  DeviceWallet = 'DEVICE_WALLET',
  /** No signer on this deployment, so a wallet cannot be made at all. */
  KeysUnavailable = 'KEYS_UNAVAILABLE',
  /** The router found no way to make this trade. */
  NoRoute = 'NO_ROUTE',
  /** The router could not be reached, so nothing was attempted. */
  RouterUnavailable = 'ROUTER_UNAVAILABLE',
}

export enum SwapErrorCode {
  // duplicated in WalletErrorCode
  // WalletNotFound = 'WALLET_NOT_FOUND',
  InsufficientBalance = 'INSUFFICIENT_BALANCE',
  SwapDataNotFound = 'SWAP_DATA_NOT_FOUND',
  PoolInfoNotFound = 'POOL_INFO_NOT_FOUND',
  BalanceNotFound = 'BALANCE_NOT_FOUND',
  BundleNotLanded = 'BUNDLE_NOT_LANDED',
  BundleWrongTransaction = 'BUNDLE_WRONG_TRANSACTION',
  BundleMissingSignatures = 'BUNDLE_MISSING_SIGNATURES',
  DexNotSupported = 'DEX_NOT_SUPPORTED',
  TipsAccountNotFound = 'TIPS_ACCOUNT_NOT_FOUND',
  UnsupportedProvider = 'UNSUPPORTED_PROVIDER',
  SwapNotCreated = 'SWAP_NOT_CREATED',
  InsufficientReserves = 'INSUFFICIENT_RESERVES',
  // duplicated in TradeErrorCode
  // UnsupportedNetwork = 'UNSUPPORTED_NETWORK',
}
export enum ReferralErrorCode {
  ReferralCodeAlreadyExists = 'REFERRAL_CODE_ALREADY_EXISTS',
}
